module.exports = __webpack_public_path__ + "static/media/edit-disable.06852231.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/edit-disable.svg
// module id = 965
// module chunks = 0